<template>
	<div id="usuario-estrutura-permissao" class="relative">
		<div class="mb-5">
			<div class="flex flex-col">
				<h4 class="subtitle mt-10 mb-4 font-bold">Cargo</h4>

				<div class="w-full mb-4">
					<ld-select
						v-if="empresas"
						class="w-full"
						parent="#usuario-estrutura-permissao"
						label="Empresa"
						name="empresa"
						:model.sync="empresaObj"
						:list.sync="empresasObj"
						:moreData="moreEmpresas"
						:search="searchEmpresa"
						:disabled="empresaDisabled || disabled"
						:changed="setEmpresaNome"
					/>

					<vs-input
						v-if="!empresas && empresaObj"
						name="empresa"
						class="w-full"
						label="Empresa"
						v-model="empresa.nome"
						:disabled="true"
					></vs-input>
				</div>

				<ld-select
					class="w-full"
					parent="#usuario-estrutura-permissao"
					name="perfil"
					:disabled="(!empresaObj && !perfil.pk) || disabled"
					label="Permissão do usuário"
					:model.sync="perfilObj"
					:changed="(item) => {
						setPerfil(item);
						removeError('perfil');
					}"
					:list.sync="perfis"
				/>
				<!-- <div class="flex w-1/2 mb-24">
				</div> -->
			</div>

			<gerenciados
				:usuarioPk="usuarioPk"
				:empresa="empresaPk ? empresaPk : empresaObj"
				:perfil="perfil"
				:gerenciados.sync="gerenciadosObj"
				:disabled.sync="disabled"
			/>

		</div>
	</div>
</template>

<script>
import Empresa from "../../../../models/Empresa";
import Gerenciados from "../gerenciados/Gerenciados";
import Usuario from '../../../../models/Usuario';

export default {
	name: "EstruturaPermissao",
	data() {
		return {
			perfis: null,
			limitParam: 20
		};
	},
	props: {
		usuarioPk: {
			type: String,
		},
		perfil: {
			required: true
		},
		perfilAtualPk: {
			type: String
		},
		empresa: {
			required: true
		},
		empresas: {
			required: true
		},
		empresaDisabled: {
			type: Boolean,
			default: false
		},
		gerenciados: {
			type: Array,
			required: true
		},
		removeError: {
			type: Function,
			required: true
		},
		edicao: {
			default: false,
			type: Boolean
		},
	},
	components: {
		Gerenciados
	},
	computed: {
		disabled() {
			return ((!this.$permissions.can('colaboradormodificar') && this.edicao) || (!this.$permissions.can('colaboradoradicionar') && !this.edicao)) && !this.$permissions.can('autenticadosuperuser');
		},
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		perfilObj: {
			set(value) {
				this.perfil.pk = value;
				// this.$emit("update:perfil", value);
			},
			get() {
				return this.perfil.pk;
			}
		},
		empresaObj: {
			set(value) {
				this.empresa.pk = value;
				// this.$emit("update:empresa", value);
			},
			get() {
				return this.empresa.pk;
			}
		},
		empresasObj: {
			set(value) {
				this.$emit("update:empresas", value);
			},
			get() {
				return this.empresas;
			}
		},
		gerenciadosObj: {
			set(value) {
				this.$emit("update:gerenciados", value);
			},
			get() {
				return this.gerenciados;
			}
		},
		perfilAtualPkModel: {
			set(value) {
				this.$emit("update:perfilAtualPk", value);
			},
			get() {
				return this.perfilAtualPk;
			}
		}
	},
	methods: {
		async moreEmpresas(params) {
			const data = {
				count: 0,
				data: []
			};

			const { empresas, totalEmpresas } = await Empresa.getEmpresas(
				params
			);

			data.count = totalEmpresas;
			data.data = empresas.map(empresa => {
				return {
					text: empresa.nome,
					value: empresa.pk
				};
			});

			return data;
		},
		async searchEmpresa(searchValue) {

            const { empresas } = await Empresa.getEmpresas({
                limit: this.limitParam,
                search: searchValue
            });

            return empresas.map(empresa => {
                return {
                    text: empresa.nome,
                    value: empresa.pk
                };
            });
        },
		setPerfis() {

			if (this.empresaPk) {
				this.perfis = this.empresa.perfis.map(perfil => {
					return {
						...perfil,
						text: perfil.nome,
						value: perfil.pk
					};
				});

				return;
			} else {
				if (this.empresaObj) {
					const empresa = this.empresas.find(
						empresa => empresa.value == this.empresaObj
					);

					if (empresa) {
						this.perfis = empresa.perfis.map(perfil => {
							return {
								...perfil,
								text: perfil.nome,
								value: perfil.pk
							};
						});
					}

					return;
				}
			}

			this.perfis = [];
		},
		setPerfil({text, isAdmin}) {
			this.perfil.nome = text;
			this.perfil.isAdmin = isAdmin;
		},
		async getGerenciados() {
			if (this.usuarioPk) {
				const loadingGenrenciados = this.$vsloading({
					container: ".popup-usuario",
					color: "#000000",
					backgroundColor: "#ffffffba",
					opacity: 1,
					width: 44,
					height: 44
				});

				try {
					const usuario = await Usuario.getUsuario(this.usuarioPk);

					if (usuario) {
						this.gerenciadosObj = usuario.gerenciados;
					}

				} catch (error) {
					console.error(error);
				} finally {
					loadingGenrenciados.hide();
				}
			}
		},
		setPerfilAtual() {
			if (!this.perfilAtualPkModel) {
				this.perfilAtualPkModel = this.perfil.pk;
			}
		},
		setEmpresaNome({text}) {
			if (!this.empresaPk) {
				this.empresa.nome = text;
			}

			this.perfilObj = null;
			this.setPerfis();
		}
	},
	watch: {
		"perfil.pk": function() {
			if (this.perfil.pk == this.perfilAtualPkModel) {
				this.getGerenciados();
			}
		},
		empresa() {
			this.setPerfis();
		}
	},
	created() {
		this.setPerfis();
		this.setPerfilAtual();
	},
};
</script>

<style lang="scss" src="./estrutura_permissao.scss"></style>
